import { DialogTrigger as AriaDialogTrigger } from "react-aria-components";

/** Shared re-export so every dialog flavor wires up triggers the same way. */
export const DialogTrigger = AriaDialogTrigger;
